import { useLocalStorage } from "usehooks-ts";
import { useEffect } from "react";
import useListenFromRn from "../utilities/useListenFromRn";
export default function useSetExpoToken(PKP) {
    var useRNHandler = useListenFromRn().useRNHandler;
    var _a = useLocalStorage('expoPushToken', ''), expoPushToken = _a[0], setExpoPushToken = _a[1];
    useRNHandler('EXPO_PUSH_TOKEN', function (payload) {
        console.log('EXPO_PUSH_TOKEN', payload);
        if (payload) {
            setExpoPushToken(payload);
        }
    });
    useEffect(function () {
        if (expoPushToken) {
            fetch('/api/db/update-expo-token.ts', {
                method: "POST",
                body: JSON.stringify({ expoPushToken: expoPushToken, PKP: PKP }),
            });
        }
    }, [expoPushToken, PKP]);
}
